import { Divider, Flex, Typography } from 'antd'
import { useTheme } from 'antd-style'

import { BasicProps } from '@eastcoal/common/types/component'
import { pick } from '@eastcoal/common/utils/object'
import { stringifyUrl } from '@eastcoal/common/utils/querystring'

import { useAuthStore } from '@eastcoal/auth/hooks/useStore'
import { EaAuditPersonIcon } from '@eastcoal/icon/EaAuditPerson'
import { RouterLink } from '@eastcoal/router/components/Link'
import { MemberType } from '@eastcoal/shared/enums/MemberType'


import { SwitchMemberButton } from './SwitchButton'
import { MemberStatus } from '@eastcoal/shared/enums/MemberStatus'

export const UserInfo = (props: BasicProps) => {
  const {
    user: { name: userName },
    member: { memberStatus, type: memberType, id: memberId },
    roles,
    administrator
  } = useAuthStore(state =>
    pick(state, ['user', 'member', 'roles', 'administrator'])
  )

  const theme = useTheme()

  const userNameNode = (
    <Flex align='center' gap={4}>
      <span>{userName}</span>
      <EaAuditPersonIcon
        style={{
          fontSize: 22
        }}
      />
    </Flex>
  )

  const dutyNode = (
    <Typography.Text
      style={{ color: theme.yellow8 }}
      ellipsis={{
        tooltip: true
      }}
    >
      {administrator
        ? '管理员'
        : roles.map(item => item.name).toString() || '暂无角色'}
    </Typography.Text>
  )

  if (memberType === MemberType.ENTERPRISE) {
    return (
      <Flex align='center' gap={4}>
        {userNameNode}
        <Divider orientation='vertical' />
        {dutyNode}
      </Flex>
    )
  }

  const auditLinkNode =
    memberStatus === MemberStatus.SUCCESS ? (
      <RouterLink to='/audit/enterprise/create'>认证企业&gt;</RouterLink>
    ) : (
      <span>
        <RouterLink
          to={stringifyUrl({
            url: '/audit/person/edit',
            query: {
              memberId
            }
          })}
        >
          实名认证&gt;
        </RouterLink>
        <Typography.Text type='secondary'>
          （认证通过即可获得完整交易权限，快来提交认证资料吧~）
        </Typography.Text>
      </span>
    )

  return (
    <Flex {...props} align='center' gap={4} wrap='nowrap'>
      {userNameNode}
      <SwitchMemberButton />
      <Divider orientation='vertical' />
      {dutyNode}
      <Divider orientation='vertical' />
      {auditLinkNode}
    </Flex>
  )
}
